import {Component, OnInit} from '@angular/core';
import {KeycloakService} from "keycloak-angular";
import {MyStorageService} from "../../services/my-storage.service";
import {TranslateService} from "@ngx-translate/core";
import {Constants} from "../../utils/constants";
import {RestaurantService} from "../../services/restaurant.service";
import {Utilities} from "../../utils/utilities";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {DailySumComponent} from "../daily-sum/daily-sum.component";

export class ReservationDateOption {
  isToday: boolean;
  dateString: string;

  constructor(isToday: boolean, dateString: string) {
    this.isToday = isToday;
    this.dateString = dateString;
  }
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  restaurants: any[];
  currentRestaurant: any;
  startDate: Date = new Date();
  availableDateList: ReservationDateOption[] = [];
  availableDate: ReservationDateOption = null;


  public localeList: any[] = [
    {code: 'hu', label: "Magyar"},
    {code: 'en', label: "Angol"}
  ];
  public isLoggedIn = false;
  authUser: any = {};

  isProduction: boolean;
  turnOffTranslations: boolean;

  constructor(
    public translate: TranslateService,
    public myStorageService: MyStorageService,
    public keycloakService: KeycloakService,
    private restaurantService: RestaurantService,
    private modalService: BsModalService,
    private window: Window) {
    for (let i = 0; i < 10; i++) {
      const tmpDate = Utilities.addDays(this.startDate, i);
      this.availableDateList.push(new ReservationDateOption((i == 0), Utilities.dateToBackendString(tmpDate)));
    }
    this.availableDate = this.myStorageService.getFromCookiesWithParse('reservationDate', this.availableDateList[0]);
    this.validateStoredDate();
  }


  private validateStoredDate() {
    if (this.availableDate.dateString == Utilities.dateToBackendString(new Date())) {
      this.availableDate.isToday = true;
      this.myStorageService.saveToCookies('reservationDate', JSON.stringify(this.availableDate));
    } else if (new Date(this.availableDate.dateString).getTime() < new Date(this.availableDateList[0].dateString).getTime()) {
      this.availableDate = this.availableDateList[0];
      this.myStorageService.saveToCookies('reservationDate', JSON.stringify(this.availableDate));
    }
  }

  ngOnInit(): void {
    this.isProduction = Utilities.isProduction();
    this.turnOffTranslations = this.myStorageService.checkKey('turnOffTranslations');
    setTimeout(() => {
      this.checkStoredRestaurantAvailable();
    }, 500);
  }

  switchLang(lang: string) {
    this.translate.use(lang);
    this.myStorageService.saveToCookies(Constants.STORAGE_KEYS.LANGUAGE, lang);
    window.location.reload();
  }

  changeRestaurant(restaurant: any) {
    this.myStorageService.saveToCookies(Constants.STORAGE_KEYS.RESTAURANT, parseInt(restaurant.historyId));
    this.switchLang(restaurant.defaultLanguage);
  }

  checkStoredRestaurantAvailable() {
    this.restaurants = this.restaurantService.getUsersRestaurants();
    let savedRestaurantId = this.myStorageService.getFromCookies(Constants.STORAGE_KEYS.RESTAURANT, null);
    savedRestaurantId = this.restaurants.find(restaurant => restaurant.historyId == savedRestaurantId) ? savedRestaurantId : null;
    if (savedRestaurantId) {
      this.currentRestaurant = this.restaurants.find(restaurant => restaurant.historyId == savedRestaurantId);
    }
  }

  translateOnOff() {
    if (!this.turnOffTranslations) {
      this.myStorageService.deleteFromCookies('turnOffTranslations');
    } else {
      this.myStorageService.saveToCookies('turnOffTranslations', {});
    }
    this.window.location.reload();
  }

  showDailySum() {
    const config = Utilities.createModalConfig({
      restaurant: this.currentRestaurant,
      startDate: new Date(this.availableDate.dateString)
    });

    const modalRef: BsModalRef = this.modalService.show(DailySumComponent, config);
    modalRef.content.onClose.subscribe(result => {
      console.log("modal yo")
    });
  }


  changeDate(availableDate) {
    this.myStorageService.saveToCookies('reservationDate', JSON.stringify(availableDate));
    this.window.location.reload();
  }

}
